module.exports = __webpack_public_path__ + "static/media/brian-chiusano.d3514a5f.jpeg";